import { Toast } from "@base-ui/react/toast";
const useToastManager = Toast.useToastManager;
const createToastManager = Toast.createToastManager;
export { createToastManager, useToastManager };
